import { getData } from 'helpers/dom'
import SwiperInstanceNative from 'customs/swiper-instance-native'
import SwiperInstanceComponent from 'customs/swiper-instance-component'
import './carousel-swiper.css'

class CarouselSwiper extends HTMLElement {
  constructor() {
    super()

    this.type = this.getAttribute('data-type') || null
    this.config = this.getAttribute('data-config') ? JSON.parse(getData('config', this)) : null
    this.options = this.getAttribute('data-options') ? JSON.parse(getData('options', this)) : null

    this.isDesignMode = window.Shopify.designMode || false

    if (this.config && this.options) {
      this.options = { ...this.options }
      this.initializeInstance()

      if (this.isDesignMode) {
        this.addDesignModeListeners()
      }
    }
  }

  initializeInstance() {
    const SwiperInstance = this.type === 'native' ? SwiperInstanceNative : SwiperInstanceComponent

    this.instance = new SwiperInstance(this, this.options, this.config, this.type)
  }

  addDesignModeListeners() {
    const reloadInstance = () => this.initializeInstance()

    document.addEventListener('shopify:section:reorder', reloadInstance)
  }
}

if (!customElements.get('carousel-swiper')) {
  customElements.define('carousel-swiper', CarouselSwiper)
}
